import { IPromise } from "angular";
import { IFieldArray } from "AngularFormly";
import {
  FieldConfigurationHelperService,
  vsName as FieldConfigurationHelperServiceName,
} from "../../../../records/forms/formly/fieldConfigurationHelpers";
import { FormViewController } from "../../../../records/forms/formView/controller";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../../records/server/serverUtility";
import fieldHelpers from "../../../../ui-formly/fieldHelpers";

import { StateService, TransitionOptions } from "@uirouter/angularjs";
import { Record } from "../../../../records/server/crud";
import { IHasResponseStatus } from "../../../../records/server/query";

const apiUrl = "/api/machines/progressives/ProgressiveDefinition";
const apiManufacturerUrl = "/api/machines/manufacturers";
const apiMeterReadingSettingUrl =
  "/api/machines/progressives/ProgressiveMeterReadingSetting";
const apiControllerTypeUrl =
  "/api/machines/progressives/ProgressiveControllerType";

export class ProgressiveDefinitionEditViewController {
  static $inject = [
    "progressiveDefinition",
    ServerUtilityName,
    FieldConfigurationHelperServiceName,
    "$state",
  ];

  public formFields: IFieldArray;

  constructor(
    private readonly progressiveDefinition: any,
    private readonly serverUtility: ServerUtility,
    fieldConfigurationHelperService: FieldConfigurationHelperService,
    private readonly $state: StateService
  ) {
    this.formFields = [
      ...fieldHelpers.columnLayout(
        [
          {
            key: "Name",
            name: "Name",
            type: "input",
            templateOptions: {
              required: true,
              label: "Name",
            },
            asyncValidators: {
              unique: ($viewValue, $modelValue, $scope) => {
                const id = $scope.model?.Id;
                return serverUtility
                  .alreadyExists({
                    url: apiUrl,
                    query: {
                      Name: $viewValue,
                    },
                    excludeId: id,
                  })
                  .then((alreadyExists) => {
                    if (alreadyExists) {
                      throw new Error();
                    }
                  });
              },
            },
          },
          fieldConfigurationHelperService.selectAsyncField({
            key: "ManufacturerId",
            name: "ManufacturerId",
            required: true,
            getDefaultItem: (model) => {
              return {
                Id: model.ManufacturerId,
                Name: model.Manufacturer?.Name,
              };
            },
            queryUrl: apiManufacturerUrl,
            useLegacyQuery: true,
            label: "Manufacturer",
          }),
          fieldConfigurationHelperService.selectAsyncField({
            key: "ProgressiveMeterReadingSettingId",
            name: "ProgressiveMeterReadingSettingId",
            label: "Meter Reading Setting",
            required: true,
            getDefaultItem: (model) => {
              return {
                Id: model.ProgressiveMeterReadingSettingId,
                Name: model.ProgressiveMeterReadingSetting?.Name,
              };
            },
            queryUrl: apiMeterReadingSettingUrl,
          }),
          {
            key: "Status",
            name: "Status",
            type: "select",
            templateOptions: {
              label: "Status",
              options: [
                {
                  label: "Active",
                  value: "Active",
                },
                {
                  label: "Inactive",
                  value: "Inactive",
                },
              ],
              required: true,
              labelProp: "label",
              valueProp: "value",
            },
          },
          fieldConfigurationHelperService.selectAsyncField({
            key: "ProgressiveControllerTypeId",
            name: "ProgressiveControllerTypeId",
            label: "Controller Type",
            required: true,
            getDefaultItem: (model) => {
              return {
                Id: model.ProgressiveControllerTypeId,
                Name: model.ProgressiveControllerType?.Name,
              };
            },
            queryUrl: apiControllerTypeUrl,
          }),
          fieldHelpers.simpleStringField({ key: "Version", name: "Version" }),
          fieldHelpers.simplePercentageField({
            key: "TotalPercentage",
            name: "TotalPercentage",
            label: "Total Percentage",
            min: 0,
            max: 100,
            step: 0.001,
          }),
        ],
        4
      ),
      ...fieldHelpers.columnLayout(
        [
          fieldConfigurationHelperService.repeaterField({
            key: "Games",
            name: "Games",
            label: "Games",
            allowAdd: true,
            showHeader: true,
            displayNameSingular: "Game",
            displayNamePlural: "Games",
            repeaterFields: [
              ...fieldHelpers.columnLayout(
                [
                  fieldHelpers.simpleStringField({
                    key: "Description",
                    name: "Description",
                    required: true,
                    label: "Description",
                  }),
                ],
                4
              ),
              fieldConfigurationHelperService.repeaterField({
                key: "Levels",
                name: "Levels",
                label: "Levels",
                allowAdd: true,
                showHeader: true,
                displayNameSingular: "Level",
                displayNamePlural: "Levels",
                repeaterFields: [
                  ...fieldHelpers.columnLayout(
                    [
                      fieldHelpers.simpleStringField({
                        key: "Name",
                        name: "Name",
                        label: "Name",
                        required: true,
                      }),
                      fieldHelpers.simplePercentageField({
                        key: "Percentage",
                        name: "Percentage",
                        label: "Percentage",
                        min: 0,
                        max: 100,
                        step: 0.001,
                      }),
                      fieldHelpers.simpleCurrencyField({
                        key: "ResetBase",
                        name: "ResetBase",
                        label: "Reset Base",
                        min: 0,
                        step: 0.01,
                      }),
                      {
                        key: "JackpotType",
                        name: "JackpotType",
                        type: "select",
                        templateOptions: {
                          label: "Jackpot Type",
                          options: [
                            {
                              label: "Linked",
                              value: "Linked",
                            },
                            {
                              label: "Standalone",
                              value: "Standalone",
                            },
                            {
                              label: "Wap",
                              value: "Wap",
                            },
                          ],
                          required: true,
                          labelProp: "label",
                          valueProp: "value",
                        },
                      },
                      fieldHelpers.simpleBoolField({
                        key: "ReadingRequired",
                        name: "ReadingRequired",
                        label: "Reading Required",
                        defaultValue: true,
                      }),
                      {
                        key: "copyDelete",
                        type: "recordRepeaterCopyDelete",
                        templateOptions: {
                          label: " ",
                          allowMove: true,
                        },
                      },
                    ],
                    4
                  ),
                ],
              }),
              {
                key: "copyDelete",
                type: "recordRepeaterCopyDelete",
                templateOptions: {
                  label: " ",
                  allowMove: true,
                },
              },
            ],
          }),
        ],
        1
      ),
      ...fieldHelpers.columnLayout(
        [
          fieldHelpers.textAreaField({
            key: "Notes",
            name: "Notes",
            label: "Notes",
            rows: 5,
          }),
        ],
        1
      ),
    ];
  }

  submit(formViewController: FormViewController): IPromise<void> {
    const isNew = !this.progressiveDefinition.Id;

    const serverPromise = isNew
      ? this.serverUtility.post<Record>({
          url: apiUrl,
          postObject: this.progressiveDefinition,
        })
      : this.serverUtility.put<Record>({
          url: apiUrl,
          updateObject: this.progressiveDefinition,
        });

    return serverPromise
      .then((r) => {
        this.navigateToGridOrDetail(r.Result);
      })
      .catch((error) => {
        const apiResponse = <IHasResponseStatus>error.data;
        formViewController.setApiErrors(apiResponse.ResponseStatus);
      });
  }

  cancel() {
    this.navigateToGridOrDetail(this.progressiveDefinition);
  }

  private navigateToGridOrDetail(record: Record) {
    const id = record.Id;

    const targetState = id
      ? "main.machines.progressives.progressiveDefinitions.detail.machines"
      : "main.machines.progressives.progressiveDefinitions";
    this.$state.go(targetState, { id }, { reload: true });
  }

  getTitle(): string {
    const record = this.progressiveDefinition;
    return record.Id
      ? `Progressive Definition - ${record.Name}`
      : "Add Progressive";
  }
}
